<script>
	import { uiStore } from '$lib/stores/uiStore.js';
	import Header from './Header.svelte';
	import Sidebar from './Sidebar.svelte';
	import XIcon from '$lib/components/icons/XIcon.svelte';
	import Toast from '$lib/components/Toast.svelte';

	$: isSidebarOpen = $uiStore.isSidebarOpen;
</script>

{#if isSidebarOpen}
	<!-- svelte-ignore a11y-click-events-have-key-events -->
	<!-- svelte-ignore a11y-no-static-element-interactions -->
	<div
		class="fixed inset-0 bg-black/50 z-40 lg:hidden"
		on:click={() => uiStore.closeSidebar()}
	></div>

	<div
		class="fixed top-0 left-0 w-64 h-screen z-50 lg:hidden bg-gray-50 border-r border-gray-200 shadow-lg"
		style="overflow-y: auto; -webkit-overflow-scrolling: touch;"
	>
		<div
			class="sticky top-0 z-10 h-16 flex items-center justify-between px-4 border-b border-gray-200 bg-gray-50"
		>
			<a href="/" class="flex items-center gap-2">
				<img src="/logo.png" alt="단비데스크 로고" class="w-[1.875rem] h-[1.875rem]" />
				<span class="text-xl font-bold" style="color: #3F5264;">단비데스크</span>
			</a>
			<button
				class="p-2 rounded-lg text-gray-600 hover border-none bg-transparent cursor-pointer"
				on:click={() => uiStore.closeSidebar()}
				aria-label="메뉴 닫기"
			>
				<XIcon class="w-5 h-5" />
			</button>
		</div>
		<Sidebar onItemClick={() => uiStore.closeSidebar()} />
	</div>
{/if}

<div class="min-h-screen bg-gray-100 overflow-x-hidden">
	<Header />

	<div class="flex">
		<aside
			class="hidden lg:block w-64 bg-gray-50 border-r border-gray-200 min-h-[calc(100vh-4rem)] max-h-[calc(100vh-4rem)] overflow-y-auto sticky top-16"
		>
			<Sidebar />
		</aside>

		<main class="flex-1 min-w-0 min-h-[calc(100vh-4rem)] bg-white">
			<slot />
		</main>
	</div>
</div>

<Toast />
